import { useEffect } from 'react';

/**
 * Custom hook to execute a callback function when the Escape key is pressed.
 * @param callback The function to call when the Escape key is pressed.
 * @param dependencies Optional dependencies array for the useEffect hook.
 */
const useEscapeKey = (callback: (...args: any[]) => void, dependencies: React.DependencyList = []) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callback();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, ...dependencies]);
};

export default useEscapeKey;
